<h3 class="color-primary" mat-dialog-title>{{data.title}}</h3>

<div mat-dialog-content>
	<div class="form-group kt-form__group row">
		<div class="col-lg-12">
			{{data.description}}
		</div>
	</div>
	<div class="form-group kt-form__group row" style="overflow-y: auto;
			max-height: 50vh;">
		<ng-container *ngIf="arraySize == 1">
			<div class="form-group kt-form__group row">
				<div class="col-lg-12">
					<mat-form-field class="example-full-width">
						<input matInput *ngIf="data.type && data.type === 'number'" type="number" [min]="data.min"
							[max]="data.max" [(ngModel)]="data.data" placeholder="{{data.placeholder}}">
						<input matInput *ngIf="!(data.type && data.type === 'number')" [(ngModel)]="data.data"
							placeholder="{{data.placeholder}}">
					</mat-form-field>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="arraySize > 1">
			<div class="form-group kt-form__group row" *ngFor="let number of getNumberRange(arraySize)">
				<div class="col-lg-2">
					<span matPrefix>{{number -1}}.</span>
				</div>
				<div class="col-lg-10">
					<mat-form-field class="example-full-width">
						<input matInput *ngIf="data.type && data.type === 'number'" type="number" [min]="data.min"
							[max]="data.max" [(ngModel)]="data.data[number-1]" placeholder="{{data.placeholder}}">
						<input matInput *ngIf="!(data.type && data.type === 'number')" [(ngModel)]="data.data[number-1]"
							placeholder="{{data.placeholder}}">
					</mat-form-field>
				</div>
			</div>
		</ng-container>
	</div>
</div>
<div mat-dialog-actions align="end">
	<button mat-button (click)="onNoClick()" color="danger">{{data.cancelbtn}}</button>&nbsp;
	<button mat-raised-button (click)="onYesClick()" cdkFocusInitial>{{data.confirmbtn}}</button>
</div>